export default __webpack_public_path__ + "b55feeeab9415d67e601a4eadfbfb5b2.png";